/**
 * safe navigation operator的な関数.
 * 存在しないプロパティを指定した場合に、第二引数（def）を返却する
 * @param {any} func function callbackにチェックしたいオブジェクト
 * @param {any} def デフォルト
 * @return {any} func or def
 */
function safe (func, def) {
  try {
    const result = func();
    return result === undefined ? def : result;
  } catch (e) {
    return def;
  }
}

export {
  safe,
};
